<template>
	<div v-if="data" :class="['sub-values', {'inline': isInactive}]">
		<div class="sub-value clickable" @click="$emit('click')">
			<div class="label">{{ typeLabel }}</div>
			<div v-if="data.items">
				<div v-for="item in data.items" :key="item.id">
					{{ item.firstName }} {{ item.lastName }} ({{ item.yearOfBirth }})
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {getLabel, TYPE__INACTIVE} from "@/helper/job-profile/IncognitoMode";

export default {
	props: {
		data: {
			type: Object,
			required: false
		}
	},

	computed: {
		isInactive ()
		{
			return this.data?.type === TYPE__INACTIVE;
		},
		typeLabel ()
		{
			return getLabel(this.data.type);
		}
	}
}
</script>
